// Missing data is not zero. Keep valid zeroes while hiding invalid API values.
export function quoteNumber(value) {
  if (!['string', 'number'].includes(typeof value) || (typeof value === 'string' && !value.trim())) return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

export function quoteDisplay(value, suffix = '', divisor = 1, digits = null) {
  const number = quoteNumber(suffix === '%' && typeof value === 'string' ? value.trim().replace(/[%％]+$/, '').trim() : value)
  if (number == null || !Number.isFinite(number / divisor)) return '--'
  const display = digits == null ? String(number / divisor) : (number / divisor).toFixed(digits)
  return (Number(display) === 0 ? display.replace(/^-/, '') : display) + suffix
}

// API percentages are already percentage points; only normalize their display.
export function quotePercent(value, digits = null) {
  return quoteDisplay(value, '%', 1, digits)
}

// Display only: preserve the original quote for calculations and order payloads.
export function quotePrice(value, suffix = '') {
  const number = quoteNumber(value)
  return quoteDisplay(value, suffix, 1, number !== null && Math.abs(number) > 0 && Math.abs(number) < 0.01 ? 3 : 2)
}
